export default "__VITE_ASSET__DWLXUIJc__"